import styled from 'styled-components'
import { Flex, Box } from 'pcln-design-system'

export const ParentFlex = styled(Flex)`
  position: relative;
`

export const StyledTileWrapper = styled(Box)`
  overflow: hidden;
  cursor: pointer;
`
